import { GzRemediationActionsWebComponent } from './component/RemediationActionsWebComponent';

export { GzRemediationActionsWebComponent };
